import React, { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import clsx from 'clsx'
import { CircularProgress } from '@mui/material'

import { AppStatus } from '~shared/models/AppStatus'
import { useGlobalStyles } from '~shared/styles/globalStyles'
import { initApp } from '~store/global/actions'
import { getAppStatus } from '~store/global/selectors'
import { getAppNavItemGroups } from '~config/navigationConfig'
import { buildNavRoutes } from '~utils/buildNavRoutes'

import AppError from './components/AppError'
import CrudeContainer from './components/Crude/CrudeContainer'
import AppRoutes from './components/AppRoutes'
import NavigationContainer from './components/NavigationContainer/NavigationContainer'
import Authenticator from './screens/Authenticator/Authenticator'
import RegistrationCustomerPortal from './screens/RegistrationCustomerPortal/RegistrationCustomerPortal'

const App: React.FC = () => {
  const gs = useGlobalStyles()
  const { i18n } = useTranslation()
  const dispatch = useDispatch()
  const appStatus = useSelector(getAppStatus)

  // on mount
  useEffect(() => {
    dispatch(initApp.started())
    localStorage.setItem('language', 'de-DE')

    // eslint-disable-next-line -- on mount
  }, [])

  // TODO NAV DATA HANDLING REFACTOR WHEN THERE IS TIME _ START
  // eslint-disable-next-line -- it is intentional for this to run on "i18n.language" to catch language changes
  const appNavItemGroups = useMemo(() => getAppNavItemGroups(), [ i18n.language ])
  // next line could move into AppRoutes component
  const navRoutes = useMemo(() => buildNavRoutes(appNavItemGroups, CrudeContainer), [appNavItemGroups])
  // todo add default route to AppRoutes component?
  // TODO NAV DATA HANDLING REFACTOR WHEN THERE IS TIME _ END

  return (appStatus === AppStatus.initialized)
    ? <Authenticator>
      <RegistrationCustomerPortal>
        <NavigationContainer
          navGroups={appNavItemGroups}
        >
          <AppRoutes navRoutes={navRoutes} />
        </NavigationContainer>
      </RegistrationCustomerPortal>
    </Authenticator>
    : (
      appStatus === AppStatus.failedInitialization
        ? <AppError />
        : <div className={clsx(gs.fullViewHeight, gs.flex, gs.flexJustifyCenter)}>
          <CircularProgress className={gs.marginTopMedium} />
        </div>
    )
}

export default App
